function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.7177 10.4679C49.049 10.4679 51.376 11.4089 53.1321 13.2996C56.6748 17.1241 56.6748 23.543 53.2018 27.4236L45.5934 35.8152L52.6135 43.106L60.2219 34.7144L60.2437 34.6885L60.2655 34.6626C67.425 26.6596 67.3379 13.7701 60.0781 5.93107C56.5354 2.10652 51.79 0 46.7177 0C44.2426 0 41.8241 0.505047 39.5407 1.50219C37.1528 2.5425 35.0263 4.06628 33.2179 6.03467L33.1482 6.11237L33.0784 6.19006L32.7952 6.5095L32.5119 6.19006L32.4422 6.10805L32.3681 6.03035C30.5597 4.06628 28.4332 2.53819 26.0453 1.49787C23.7532 0.505047 21.3391 0 18.864 0C13.7917 0 9.04193 2.10652 5.4992 5.93107C-1.76055 13.7744 -1.84335 26.6639 5.31618 34.6626L5.33797 34.6885L5.35976 34.7144L12.9681 43.106L19.9882 35.8152L12.3798 27.4279C8.90684 23.543 8.90684 17.1284 12.4452 13.3039C14.2013 11.4089 16.5283 10.4679 18.8596 10.4722C21.2345 10.4722 23.6137 11.4477 25.3916 13.3816L32.7865 21.7731L40.1813 13.3816C41.9636 11.4434 44.3428 10.4679 46.7177 10.4679Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8047 49.9699L20.0064 35.8545L12.9863 43.1453L25.7846 57.2564L32.8047 65.0005L39.8248 57.2564L52.623 43.1453L45.6029 35.8545L32.8047 49.9699Z",
  fill: "#3A3A3A"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 32.7892,
  y1: 1.48773,
  x2: 32.7892,
  y2: 35.8835,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA870"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7687B"
})));

var SvgDarkLogo = function SvgDarkLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDarkLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dark-logo.25a8a2a1.svg";
export { ForwardRef as ReactComponent };